module.exports = __webpack_public_path__ + "static/media/loading.671fb81c.gif";